import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'
import { pick } from '@eastcoal/common/utils/object'

/**
 * 业务类型
 */
export enum BizType {
  /**
   * 竞拍
   */
  TRADITION_AUCTION = 0,
  /**
   * 竞拍（房屋）
   */
  HOUSE_AUCTION = 1,
  /**
   * 竞拍（排名）
   */
  RANKING_AUCTION = 2,
  /**
   * 密函
   */
  SECRET_AUCTION = 3,
  /**
   * 招标
   */
  TENDER_AUCTION = 4,
  /**
   * 询比价
   */
  INQUIRY_AUCTION = 5,
  /**
   * 减价
   */
  PRICE_CUT_AUCTION = 6,
  /**
   * 比价
   */
  PRICE_COMPARE = 7,
  /**
   * 挂牌
   */
  LISTING = 8,
  /**
   * 资金账户
   */
  ACCOUNT = 9
}

export const BizTypeTextMap = {
  [BizType.TRADITION_AUCTION]: '竞拍',
  [BizType.RANKING_AUCTION]: '竞拍(排名)',
  [BizType.HOUSE_AUCTION]: '竞拍(房屋)',
  [BizType.SECRET_AUCTION]: '密函',
  [BizType.TENDER_AUCTION]: '招标',
  [BizType.INQUIRY_AUCTION]: '询比价',
  [BizType.PRICE_CUT_AUCTION]: '减价',
  [BizType.PRICE_COMPARE]: '比价采购',
  [BizType.LISTING]: '挂牌',
  [BizType.ACCOUNT]: '资金账户'
}

export const BizTypeColorMap = {
  [BizType.TRADITION_AUCTION]: 'blue',
  [BizType.HOUSE_AUCTION]: 'blue',
  [BizType.RANKING_AUCTION]: 'blue',
  [BizType.SECRET_AUCTION]: 'blue',
  [BizType.PRICE_CUT_AUCTION]: 'blue ',
  [BizType.TENDER_AUCTION]: 'orange',
  [BizType.INQUIRY_AUCTION]: 'orange',
  [BizType.PRICE_COMPARE]: 'volcano',
  [BizType.LISTING]: 'purple',
  [BizType.ACCOUNT]: 'green'
}

/**
 * 真实的业务类型
 */
export const RealBizTypeOptions = mapNumberEnumOptions(
  pick(BizTypeTextMap, [
    BizType.TRADITION_AUCTION,
    BizType.HOUSE_AUCTION,
    BizType.RANKING_AUCTION,
    BizType.TENDER_AUCTION,
    BizType.INQUIRY_AUCTION,
    BizType.PRICE_COMPARE,
    BizType.LISTING
  ])
)
